import React from 'react';
import '../App.css';
import logos from './images/Vector.png';

export default function Thank() {
  return (
    <div className="footer-container bg-dark text-light pt-5">
      <div className="container">
        <div className="row g-4">

          
          <div className="col-lg-2  col-12 mb-4 text-center">
            <img src={logos} alt="Company Logo" style={{ width: '150px' }} />
          </div>

         
          <div className="col-lg-4  col-12 mb-4">
            
            <h5 className="mt-3">Follow us</h5>
            <div className="d-flex gap-3 mt-2">
  <a href="https://www.facebook.com/p/MDQuality-Apps-Solutions-100064061977997/" target="_blank" rel="noopener noreferrer" style={{ color: '#1877F2' }}>
    <i className="bi bi-facebook fs-4"></i>
  </a>
  <a href="https://www.youtube.com/@MDQualityApps" target="_blank" rel="noopener noreferrer" style={{ color: '#FF0000' }}>
    <i className="bi bi-youtube fs-4"></i>
  </a>
  <a href="https://www.instagram.com/mdqualityapps/" target="_blank" rel="noopener noreferrer" style={{ color: '#E1306C' }}>
    <i className="bi bi-instagram fs-4"></i>
  </a>
  <a href="https://in.linkedin.com/company/mdquality-apps-solutions" target="_blank" rel="noopener noreferrer" style={{ color: '#0A66C2' }}>
    <i className="bi bi-linkedin fs-4"></i>
  </a>
  <a href="https://x.com/mdqualityapps" target="_blank" rel="noopener noreferrer" style={{ color: '#000000' }}>
    <i className="bi bi-twitter fs-4"></i>
  </a>
</div>

          </div>

          <div className="col-lg-6 col-12 mb-4">
            <div>



              <div>
                <div className="map-responsive" style={{ borderRadius: '8px', overflow: 'hidden' }}>
               
                  <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3699.3803854298226!2d80.17251437479496!3d13.059415612947467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5261832f9b6285%3A0x6814312c6059121e!2sMDQuality%20Apps%20Solutions!5e1!3m2!1sen!2sin!4v1749817005992!5m2!1sen!2sin"
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe> 
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
